<div
  #select
  (click)="isOpen = !isOpen;"
  class="flex items-center cursor-pointer px-4 w-full border-radius ring-lPrimary dark:ring-lPrimaryLight border border-color text-base min-h-12 transition-shadow"
  [ngClass]="isOpen ? 'ring-1 border-lPrimary dark:border-lPrimaryLight' : ''"
>
  <div class="flex-1 overflow-x-auto">
    <span class="subtext-color" *ngIf="!selectedContent.length">{{ placeholder }}</span>

    <ng-container *ngIf="selectedContent.length && labelTemplate">
      <ng-container *ngTemplateOutlet="labelTemplate; context: { $implicit: selectedContent }" />
    </ng-container>

    <div *ngIf="selectedContent.length && !labelTemplate" class="flex gap-2">
      <span
        *ngFor="let s of selectedContent; let i = index"
        class="text-base text-color whitespace-nowrap"
      >
        {{ s[showKey || key] + ';' }}
      </span>
    </div>

  </div>

  <l-icon class="subtext-color text-3xl">
    {{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
  </l-icon>
</div>

<div
  class="absolute flex flex-col gap-4 foreground border-2 border-radius p-5 w-full z-50 h-80"
  [style]="'top: ' + (select.clientHeight + 10) + 'px'"
  *ngIf="!modal && isOpen"
>
  <ng-container *ngTemplateOutlet="table" />
</div>

<div
  class="fixed flex justify-center items-center top-0 left-0 w-screen h-screen bg-black/50 z-50"
  *ngIf="modal && isOpen"
>
  <div lOutsideClick (outsideClick)="isOpen = false" class="flex flex-col gap-4 foreground border-radius p-8 w-4/5 h-4/5">
    <h1 class="text-xl font-bold text-color">{{ placeholder }}</h1>

    <ng-container *ngTemplateOutlet="table" />

    <div class="flex justify-end w-full">
      <button (click)="isOpen = false" class="w-min" lButton bType="primary">
        Fechar
      </button>
    </div>
  </div>
</div>

<ng-template #table>
  <input
    *ngIf="search"
    [(ngModel)]="searchValue"
    (ngModelChange)="loadSearch()" lInput
    placeholder="Pesquisar"
  >

  <div class="flex-1 py-2 overflow-y-auto">
    <p-table
      [value]="data"
      [dataKey]="key"
      [selectionPageOnly]="true"
      [(selection)]="selectedContent"
      tableStyleClass="table"
    >
      <ng-template pTemplate="header">
        <tr>
            <th *ngIf="headerTemplate" class="w-2" scope="col">
            <p-tableHeaderCheckbox *ngIf="multiple" />
          </th>
          <ng-container *ngTemplateOutlet="headerTemplate" />
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-c>
        <tr>
          <td class="w-2">
            <p-tableCheckbox [value]="c" *ngIf="multiple" />
            <p-tableRadioButton [value]="c" *ngIf="!multiple" />
          </td>
          <td *ngIf="!optionTemplate">
            {{ c[showKey || key] }}
          </td>
          <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: c }" />
        </tr>
      </ng-template>
    </p-table>

    <div class="w-full gap-5 pt-5 flex items-center justify-end" *ngIf="showPagination && config?.load">
      <p class="text-color">Mostrando {{ ((page - 1) * size + 1)  }} - {{ (page * size) > total ? total : (page * size) }} de {{ total }}</p>
      <div class="flex">
        <l-icon
          class="text-color cursor-pointer text-xs hover:opacity-85 p-2 {{ isFirstPage ? 'opacity-10 pointer-events-none' : '' }}"
          icon="chevron_left"
          (click)="prevPage()"
        />
        <l-icon
          class="text-color cursor-pointer hover:opacity-85 p-2 {{ isLastPage ? 'opacity-10 pointer-events-none' : '' }}"
          icon="chevron_right"
          (click)="nextPage()"
        />
      </div>
    </div>
  </div>
</ng-template>
